import { render, staticRenderFns } from "./BCorpLogo.vue?vue&type=template&id=1ef40e55&"
import script from "./BCorpLogo.vue?vue&type=script&lang=js&"
export * from "./BCorpLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports